module.exports = __webpack_public_path__ + "7bef5c0fccca477e38742bd45109d94b.otf";